<template>
  <div></div>
</template>

<script>
import { contactRequestsClient } from '@/api/clients/index';

export default {
  props: {
    contactRequestId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    contactRequestsClient
      .read(this.contactRequestId, {
        include: 'pipelineStage',
      })
      .then((response) => {
        if (response.data.pipelineStage) {
          this.redirectToAccountPipeline(response.data);
        } else {
          this.redirectToAccountContactRequests(response.data);
        }
      })
      .catch(() => {
        this.$router.replace('/404');
      });
  },
  methods: {
    redirectToAccountPipeline(contactRequest) {
      const { account_id, pipelineStage } = contactRequest;
      this.$router.replace({
        name: 'accounts.pipelines.pipelineUuid',
        params: {
          accountId: account_id,
          pipelineUuid: pipelineStage.pipelineId,
        },
        query: {
          contact_request_id: contactRequest.id,
        },
      });
    },
    redirectToAccountContactRequests(contactRequest) {
      const { account_id, id } = contactRequest;
      this.$router.replace({
        name: 'accounts.accountId.contactRequests',
        params: {
          accountId: account_id,
        },
        query: {
          contact_request_id: id,
        },
      });
    },
  },
};
</script>
